import React, { useEffect, useState, useRef } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { motion } from "framer-motion";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertFromRaw,
  convertToRaw,
} from "draft-js";
import { toast } from "react-toastify";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import DeleteIcon from "@mui/icons-material/Delete";
import draftToHtml from "draftjs-to-html";

const OperatorCms = () => {
  const [rowData, setRowData] = useState<any>([]);
  const [operator, setOperator] = useState<any>("0");
  const [section, setSection] = useState<Number>(0);
  const [title, setTitle] = useState<string>("");
  const [shortCode, setShortCode] = useState<string>("");
  const [display_description, setDisplayDescription] = useState<string>("");
  const [display_description_en_gb, setDisplayDescriptionEnGb] =
    useState<string>("");
  const [display_description_es, setDisplayDescriptionES] =
    useState<string>("");
  const [display_description_fr, setDisplayDescriptionFR] =
    useState<string>("");
  const [display_description_de, setDisplayDescriptionDE] =
    useState<string>("");
  const [display_description_it, setDisplayDescriptionIT] =
    useState<string>("");
  const [editorState, setEditorState] = useState<EditorState>();
  const [editorStateEnGb, setEditorStateEnGb] = useState<EditorState>();
  const [editorStateEs, setEditorStateES] = useState<EditorState>();
  const [editorStateFr, setEditorStateFR] = useState<EditorState>();
  const [editorStateDe, setEditorStateDE] = useState<EditorState>();
  const [editorStateIt, setEditorStateIT] = useState<EditorState>();
  const [submitRequest, setSubmitRequest] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [product, setProduct] = useState<any>("0");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [Open, setOpen] = useState<boolean>(false);
  const [circular, setCircular] = useState<boolean>(true);
  const [about, setAbout] = useState<any>([]);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [preview, setPreview] = useState<boolean>(false);
  const [faqs, setFaqs] = useState<any>([]);
  const [edit_faqs, setEditFaqs] = useState<any>({});
  const [delete_faq, setDeleteFaq] = useState<any>([]);
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [deleteCheck, setDeleteCheck] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [isTranslateCheck, setIsTranslateCheck] = useState<boolean>(false);
  const [IsTranslateAbout, setIsTranslateAbout] = useState<boolean>(false);
  const [IsTranslateFaq, setIsTranslateFaq] = useState<boolean>(false);
  const [activeLang, setActiveLang] = useState<any>("en");
  const faqSectionRef = useRef<HTMLDivElement | null>(null);
  const [subCategoriesData, setSubCategoriesData] = useState<any>([]);

  const languages = ["en", "en-gb", "es", "fr", "it", "de"];

  const initializeFaqData = () => {
    const defaultState: any = {};
    languages.forEach((lang) => {
      defaultState[lang] = {
        question: "",
        answer: "",
        isRedeem: false,
        editorState: EditorState.createEmpty(),
      };
    });
    return defaultState;
  };

  const [faqData, setFaqData] = useState<any>(initializeFaqData());
  const loadCountries = async () => {
    await fetch("/data/country.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.countries);
      });
  };
  console.log(operator);
  const controller = new AbortController();

  useEffect(() => {
    loadCountries();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (country == "0" || country == undefined || product == "0") {
      setIsOpen(false);
      setOpen(false);
      setCircular(false);
    } else {
      setRowData([]);
      setSubCategoriesData([]);
      if (product == "occasion") {
        getSubcategories();
      } else {
        getOperator();
      }
      setSection(0);
      setIsOpen(true);
      setCircular(true);
      setOperator(0);
      setFaqs([]);
    }
  }, [country, product]);

  useEffect(() => {
    if (operator != "0" && section == 1) {
      getDescription(operator);
    }
  }, [operator, section]);
  useEffect(() => {
    if (operator != "0" && section == 2) {
      getFAQ();
    }
  }, [operator, section]);

  useEffect(() => {
    if (isCheck && isTranslateCheck) {
      updateEditorAndDisplayFaq();
    }
  }, [edit_faqs, activeLang]);

  useEffect(() => {
    if (operator == "0") {
      setOpen(false);
    } else {
      setOpen(true);
      setShortCode(operator.operatorShortCode || "");
      setTitle(operator.operatorName || "");
      ClearFaq();
    }
  }, [operator]);

  const updateDescriptionForLang = (
    description: string,
    setEditorStateFn: (value: EditorState) => void,
    setDisplayDescriptionFn: (value: string) => void
  ) => {
    if (description) {
      const blocksFromHTML = convertFromHTML(description);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorStateFn(newEditorState);
      setDisplayDescriptionFn(description);
    } else {
      setEditorStateFn(EditorState.createEmpty());
      setDisplayDescriptionFn("");
    }
  };
  useEffect(() => {
    const updateEditorAndDisplayDescription = () => {
      const details = about.payload?.detail || [];

      const langConfigs = [
        {
          lang: "en",
          setEditor: setEditorState,
          setDisplay: setDisplayDescription,
        },
        {
          lang: "en-gb",
          setEditor: setEditorStateEnGb,
          setDisplay: setDisplayDescriptionEnGb,
        },
        {
          lang: "es",
          setEditor: setEditorStateES,
          setDisplay: setDisplayDescriptionES,
        },
        {
          lang: "fr",
          setEditor: setEditorStateFR,
          setDisplay: setDisplayDescriptionFR,
        },
        {
          lang: "de",
          setEditor: setEditorStateDE,
          setDisplay: setDisplayDescriptionDE,
        },
        {
          lang: "it",
          setEditor: setEditorStateIT,
          setDisplay: setDisplayDescriptionIT,
        },
      ];

      if (details.length > 0) {
        langConfigs.forEach(({ lang, setEditor, setDisplay }) => {
          const description =
            details.find((item: any) => item.language === lang)?.description ||
            "";
          updateDescriptionForLang(description, setEditor, setDisplay);
        });
      } else {
        // Clear all editors and displays if detail is empty
        langConfigs.forEach(({ setEditor, setDisplay }) => {
          setEditor(EditorState.createEmpty());
          setDisplay("");
        });
      }
    };

    updateEditorAndDisplayDescription();
  }, [about]);

  const updateEditorAndDisplayFaq = () => {
    if (edit_faqs && edit_faqs.length > 0) {
      const updatedFaqData: any = {};

      languages.forEach((lang) => {
        const matchingFaq = edit_faqs.find((faq: any) => faq.language === lang);

        if (matchingFaq) {
          const blocksFromHTML = convertFromHTML(matchingFaq?.answer || "");
          const contentState = ContentState.createFromBlockArray(
            blocksFromHTML.contentBlocks,
            blocksFromHTML.entityMap
          );
          const editorState = EditorState.createWithContent(contentState);

          updatedFaqData[lang] = {
            question: matchingFaq?.question || "",
            answer: matchingFaq?.answer || "",
            isRedeem: matchingFaq?.isRedeem || false,
            editorState,
          };
        } else {
          // Optional: set empty state for tabs with no FAQ
          updatedFaqData[lang] = {
            question: "",
            answer: "",
            isRedeem: false,
            editorState: EditorState.createEmpty(),
          };
        }
      });

      setFaqData(updatedFaqData);
    }
  };

  const updateEditorAndDisplay = (newEditorState: EditorState) => {
    const value = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    setFaqData((prev: any) => ({
      ...prev,
      [activeLang]: {
        ...prev[activeLang],
        editorState: newEditorState,
        answer: value,
      },
    }));
  };

  const onEditorFaqChange = (newEditorState: EditorState) => {
    updateEditorAndDisplay(newEditorState);
  };

  //EN
  const updateDescription = (newEditorState: EditorState) => {
    setEditorState(newEditorState);

    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayDescription(value);
  };

  const onEditorStateChange = (newEditorState: EditorState) => {
    updateDescription(newEditorState);
  };
  //EN-GB
  const updateEnGbDescription = (newEditorState: EditorState) => {
    setEditorStateEnGb(newEditorState);

    const contentStateEnGb = newEditorState.getCurrentContent();
    const isEmpty =
      !contentStateEnGb.hasText() ||
      contentStateEnGb.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentStateEnGb));
    setDisplayDescriptionEnGb(value);
  };

  const onEditorEnGBChange = (newEditorState: EditorState) => {
    updateEnGbDescription(newEditorState);
  };
  //spanish
  const updateESDescription = (newEditorState: EditorState) => {
    setEditorStateES(newEditorState);

    const contentStateEs = newEditorState.getCurrentContent();
    const isEmpty =
      !contentStateEs.hasText() || contentStateEs.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentStateEs));
    setDisplayDescriptionES(value);
  };

  const onEditorESChange = (newEditorState: EditorState) => {
    updateESDescription(newEditorState);
  };
  //french
  const updateFRDescription = (newEditorState: EditorState) => {
    setEditorStateFR(newEditorState);

    const contentStateFr = newEditorState.getCurrentContent();
    const isEmpty =
      !contentStateFr.hasText() || contentStateFr.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentStateFr));
    setDisplayDescriptionFR(value);
  };

  const onEditorFRChange = (newEditorState: EditorState) => {
    updateFRDescription(newEditorState);
  };

  //dutch
  const updateDEDescription = (newEditorState: EditorState) => {
    setEditorStateDE(newEditorState);

    const contentStateDe = newEditorState.getCurrentContent();
    const isEmpty =
      !contentStateDe.hasText() || contentStateDe.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentStateDe));
    setDisplayDescriptionDE(value);
  };

  const onEditorDEChange = (newEditorState: EditorState) => {
    updateDEDescription(newEditorState);
  };
  //Italian
  const updateITDescription = (newEditorState: EditorState) => {
    setEditorStateIT(newEditorState);

    const contentStateIt = newEditorState.getCurrentContent();
    const isEmpty =
      !contentStateIt.hasText() || contentStateIt.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentStateIt));
    setDisplayDescriptionIT(value);
  };

  const onEditorITChange = (newEditorState: EditorState) => {
    updateITDescription(newEditorState);
  };
  const getSubcategories = async () => {
    try {
      const response = await axiosInterceptorInstance.get(
        `/FusionHubCrm/SubCategories?Category=${product}`
      ); // replace with your real API endpoint
      const data = response.data.payload;
      setSubCategoriesData(data);
    } catch (error) {
      console.error("Failed to fetch subcategories:", error);
    }
  };
  const getOperator = async () => {
    toast.dismiss();
    await axiosInterceptorInstance
      .post(
        `/FusionHubCrm/GetOperators`,
        {
          Page: 1,
          RecordsPerPage: 999,
          operatorFilters: {
            CountryIsoCode: country.isoCode2,
            CurrencyCode: "USD",
            CategoryAliasName: product,
          },
        },
        { signal: controller.signal }
      )
      .then((response: any) => {
        const responseData = response?.data.payload;
        let finalData: any[] = [];
        responseData.forEach((item: any) => {
          finalData.push(item.operator);
        });
        if (finalData.length == 0) {
          toast.error("No Record Found");
          setCircular(false);
        } else {
          setRowData(finalData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSave = async () => {
    toast.dismiss();
    if (title !== "" && shortCode !== "" && operator !== "0" && section == 1) {
      AddDescription();
    } else if (
      title !== "" &&
      shortCode !== "" &&
      operator !== "0" &&
      section == 2
    ) {
      CheckFaqAndDescription();
    } else {
      toast.error("Please enter the required inputs.");
    }
  };

  const AddDescription = async () => {
    setSubmitRequest(true);
    await sendCreditAxios
      .post(`/CRMOperatorDetail/AddUpdateOperatorDetail`, {
        operatorId: operator.operatorId || 1,
        operatorShortCode: operator?.operatorShortCode,
        category: product,
        countryISOCode: country.isoCode2,
        detail: [
          {
            language: "En",
            description: display_description ? display_description : "",
          },
          {
            language: "En-Gb",
            description: display_description_en_gb
              ? display_description_en_gb
              : "",
          },
          {
            language: "ES",
            description: display_description_es ? display_description_es : "",
          },
          {
            language: "FR",
            description: display_description_fr ? display_description_fr : "",
          },
          {
            language: "DE",
            description: display_description_de ? display_description_de : "",
          },
          {
            language: "IT",
            description: display_description_it ? display_description_it : "",
          },
        ],
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };

  const getDescription = async (operator: any) => {
    await sendCreditAxios
      .post(`/CRMOperatorDetail/GetOperatorDetailByShortCodeAsync`, {
        operatorShortCode: operator?.operatorShortCode,
        category: product,
        countryISOCode: country.isoCode2,
        language: "",
      })
      .then((response) => {
        const responseData = response.data;
        setAbout(responseData);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const getFAQ = async () => {
    toast.dismiss();

    await sendCreditAxios
      .post(`/CRMFAQ/GetFaqByOperator`, {
        operatorShortCode: operator?.operatorShortCode,
        category: product,
        countryISOCode: country.isoCode2,
      })
      .then((response) => {
        if (response?.data.payload) {
          const responseData = response?.data.payload.data;
          setFaqs(responseData);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const deleteFAQ = async () => {
    setAction(true);
    await sendCreditAxios
      .delete(`/CRMFAQ/DeleteOperatorFAQ`, {
        data: {
          questionCode: delete_faq.questionCode,
        },
      })
      .then((res: any) => {
        const data = res.data;
        setDeleteCheck(false);
        setAction(false);
        getFAQ();
        toast.success(data.message);
        ClearFaq();
      })
      .catch((error: any) => {
        setAction(false);
        setDeleteCheck(false);
      });
  };

  const ClearFaq = () => {
    setIsCheck(false);
    setIsTranslateCheck(false);
    setEditFaqs({});

    const clearedEditor = EditorState.createEmpty();
    const clearedState = {
      question: "",
      answer: "",
      isRedeem: false,
      editorState: clearedEditor,
    };

    const resetFaqData: any = {};

    languages.forEach((lang) => {
      resetFaqData[lang] = { ...clearedState };
    });

    setFaqData(resetFaqData);
  };

  const CheckFaqAndDescription = async () => {
    setSubmitRequest(true);

    const isAllValid = languages.every(
      (lang) =>
        faqData[lang]?.question.trim().length > 0 &&
        faqData[lang]?.answer.trim().length > 0
    );

    if (!isAllValid) {
      toast.warn(
        "All tabs must have a question and answer with at least 3 characters."
      );
      setSubmitRequest(false);
      return;
    }

    const detail = languages.map((lang) => {
      const langFaq = faqData[lang] || {};
      const matchingEditFaq = Array.isArray(edit_faqs)
        ? edit_faqs.find((f: any) => f.language === lang)
        : null;

      return {
        ...(isCheck && {
          faqId: matchingEditFaq?.faqId,
          questionCode: edit_faqs[0].questionCode,
        }),
        language: lang,
        question: langFaq?.question || "",
        answer: langFaq?.answer || "",
        isRedeem: langFaq?.isRedeem || false,
      };
    });

    const payload = {
      operatorId: operator.operatorId || 1,
      operatorShortCode: operator?.operatorShortCode,
      category: product,
      operatorName: operator?.operatorName,
      countryISOCode: country.isoCode2,
      detail,
    };
    try {
      const apiPath = "/CRMFAQ/AddUpdateOperatorFAQ";
      const res = await sendCreditAxios.post(apiPath, payload);
      toast.success(res?.data?.message || "FAQ saved");
      getFAQ();
      ClearFaq();
    } catch (err) {
      toast.error("Something went wrong.");
      setSubmitRequest(false);
    } finally {
      setSubmitRequest(false);
    }
  };

  const handleTranslate = async () => {
    toast.dismiss();
    setIsTranslateCheck(false);
    setIsTranslateFaq(true);

    const source = faqData[activeLang];

    const isValid =
      source.question.trim().length >= 3 &&
      source.answer.trim().length >= 3 &&
      source.editorState;

    const clearedEditor = EditorState.createEmpty();
    const clearedState = {
      question: "",
      answer: "",
      isRedeem: false,
      editorState: clearedEditor,
    };

    const newFaqData: any = {};

    if (activeLang === "en-gb") {
      toast.warn("Please translate from EN or another language tab.");
      setIsTranslateFaq(false);
      return;
    }

    if (!isValid) {
      toast.warn(
        "Minimum 3 characters required in current tab. Clearing all tabs."
      );
      languages.forEach((lang) => {
        newFaqData[lang] = { ...clearedState };
      });
      setFaqData(newFaqData);
      setIsTranslateFaq(false);
      return;
    }

    const rawAnswerContent = convertToRaw(
      source.editorState.getCurrentContent()
    );
    const htmlAnswer = draftToHtml(rawAnswerContent);

    const copiedEditorState = EditorState.createWithContent(
      convertFromRaw(rawAnswerContent)
    );

    const questionText = source.question;
    const answerHtml = htmlAnswer;

    const sourceLang = activeLang;
    const targetLangs = languages.filter(
      (lang) => lang !== sourceLang && lang !== "en-gb"
    );

    try {
      const response = await axiosInterceptorInstance.post(
        "/Translate/TextTraslate",
        {
          text: [answerHtml, questionText],
          sourceLang,
          targetLang: targetLangs,
          format: "html",
        }
      );

      const results = response?.data?.translateResult || [];
      if (!results.length) {
        toast.error("Translation failed.");
        setIsTranslateFaq(false);
        return;
      }

      // Loop through translation results
      results.forEach((item: any) => {
        const targetLang = item.targetedlanguage;
        const translatedAnswerHTML = item.translatedText?.[0] || "";
        const translatedQuestion = item.translatedText?.[1] || "";

        const blocksFromHTML = convertFromHTML(translatedAnswerHTML);
        const contentStateTranslated = ContentState.createFromBlockArray(
          blocksFromHTML.contentBlocks,
          blocksFromHTML.entityMap
        );
        const editorStateTranslated = EditorState.createWithContent(
          contentStateTranslated
        );

        newFaqData[targetLang] = {
          question: translatedQuestion,
          answer: translatedAnswerHTML,
          isRedeem: source.isRedeem,
          editorState: editorStateTranslated,
        };

        // ✅ If targetLang is 'en', also copy to 'en-gb'
        if (targetLang === "en") {
          newFaqData["en-gb"] = {
            question: translatedQuestion,
            answer: translatedAnswerHTML,
            isRedeem: source.isRedeem,
            editorState: editorStateTranslated,
          };
        }
      });

      // Set source language content to its own tab
      newFaqData[sourceLang] = {
        question: questionText,
        answer: answerHtml,
        isRedeem: source.isRedeem,
        editorState: copiedEditorState,
      };

      // ✅ If activeLang is 'en', copy it to 'en-gb' as well
      if (activeLang === "en") {
        newFaqData["en-gb"] = {
          question: questionText,
          answer: answerHtml,
          isRedeem: source.isRedeem,
          editorState: copiedEditorState,
        };
      }

      setFaqData(newFaqData);
      toast.success("Translation applied successfully.");
    } catch (error) {
      console.error("Translation API error:", error);
      toast.error("An error occurred during translation.");
    } finally {
      setIsTranslateFaq(false);
    }
  };

  const handleTranslateAbout = async () => {
    setIsTranslateAbout(true);

    if (!editorState) return;

    const contentState = editorState.getCurrentContent();
    const plainText = contentState.getPlainText().trim();

    if (plainText.length < 3) {
      toast.warn(
        "Please write at least 3 characters in About Editor before translating."
      );
      setIsTranslateAbout(false);
      return;
    }

    try {
      const aboutLangs = ["es", "fr", "de", "it"]; // Add more target languages here
      const rawContent = convertToRaw(contentState);
      const htmlContent = draftToHtml(rawContent);

      const payload = {
        text: [htmlContent],
        sourceLang: "en",
        targetLang: aboutLangs,
        format: "html",
      };

      const res = await axiosInterceptorInstance.post(
        "/Translate/TextTraslate",
        payload
      );
      const translatedResults = res?.data?.translateResult;

      if (!Array.isArray(translatedResults)) {
        toast.error("Translation failed.");
        setIsTranslateAbout(false);
        return;
      }

      // Map language code to setState handlers
      const languageHandlers: Record<
        string,
        {
          setEditorStateFn: (value: EditorState) => void;
          setDisplayFn: (value: string) => void;
        }
      > = {
        es: {
          setEditorStateFn: setEditorStateES,
          setDisplayFn: setDisplayDescriptionES,
        },
        fr: {
          setEditorStateFn: setEditorStateFR,
          setDisplayFn: setDisplayDescriptionFR,
        },
        de: {
          setEditorStateFn: setEditorStateDE,
          setDisplayFn: setDisplayDescriptionDE,
        },
        it: {
          setEditorStateFn: setEditorStateIT,
          setDisplayFn: setDisplayDescriptionIT,
        },
      };

      translatedResults.forEach((item) => {
        const lang = item.targetedlanguage;
        const html = item.translatedText?.[0]; // Safely access first translated string

        if (html && languageHandlers[lang]) {
          const blocks = convertFromHTML(html);
          const contentStateTranslated = ContentState.createFromBlockArray(
            blocks.contentBlocks,
            blocks.entityMap
          );
          const newEditorState = EditorState.createWithContent(
            contentStateTranslated
          );

          languageHandlers[lang].setEditorStateFn(newEditorState);
          languageHandlers[lang].setDisplayFn(html);
        }
      });

      // Copy original English to en-gb
      const copiedEditorState = EditorState.createWithContent(
        convertFromRaw(rawContent)
      );
      setEditorStateEnGb(copiedEditorState);
      setDisplayDescriptionEnGb(htmlContent);
    } catch (error) {
      console.error("Translation API error:", error);
      toast.error("An error occurred during translation.");
    } finally {
      setIsTranslateAbout(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Operator CMS</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || "0"}
                          defaultValue={country?.isoCode2 || "0"}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Product Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={product}
                        defaultValue={product}
                        onChange={(e: any) => {
                          setProduct(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>
                        <MenuItem value="gift_cards"> Gift Card </MenuItem>
                        <MenuItem value="mobile">Mobile</MenuItem>
                        <MenuItem value="utilities">Utilities</MenuItem>
                        <MenuItem value="occasion">Occasion</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
            {circular == true &&
              rowData.length == 0 &&
              subCategoriesData.length == 0 && (
                <div className="circular-loader">
                  <CircularProgress size={40} />
                </div>
              )}
            {isOpen && (rowData.length > 0 || subCategoriesData.length > 0) && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Operator Selection:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          {product == "occasion" ? "Subcategory" : "Operator"}
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={
                            product == "occasion"
                              ? operator?.subCategoryObj
                                  ?.subCategoryShortCode || "0"
                              : operator?.operatorId || "0"
                          }
                          onChange={(e: any) => {
                            const value = e.target.value;

                            if (value === "0") {
                              setOperator("0");
                              return;
                            }

                            if (product === "occasion") {
                              const selected = subCategoriesData.find(
                                (item: any) =>
                                  item.subCategoryObj?.subCategoryShortCode ===
                                  value
                              );

                              setOperator({
                                operatorName:
                                  selected?.subCategoryObj?.subCategoryName,
                                operatorShortCode:
                                  selected?.subCategoryObj
                                    ?.subCategoryShortCode,
                                ...selected,
                              });
                            } else {
                              const selected = rowData.find(
                                (item: any) => item.operatorId === value
                              );
                              setOperator(selected);
                            }
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>

                          {product == "occasion"
                            ? subCategoriesData.map(
                                (item: any, index: number) => (
                                  <MenuItem
                                    key={index}
                                    value={
                                      item.subCategoryObj?.subCategoryShortCode
                                    }
                                  >
                                    {item.subCategoryObj?.subCategoryName}
                                  </MenuItem>
                                )
                              )
                            : rowData.map((item: any, index: number) => (
                                <MenuItem key={index} value={item.operatorId}>
                                  {item.operatorName}
                                </MenuItem>
                              ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Section
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={section}
                          defaultValue={section}
                          onChange={(e: any) => {
                            setSection(e.target.value);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>
                          <MenuItem value="1"> About</MenuItem>
                          <MenuItem value="2">FAQ</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}
            {Open && section != 0 && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Operator Information:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="Title"
                        variant="outlined"
                        value={title}
                        inputProps={{ maxLength: 200 }}
                        onChange={(e: any) => {
                          setTitle(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="Short Code"
                        variant="outlined"
                        value={shortCode}
                        inputProps={{ maxLength: 200, readOnly: true }}
                        onChange={(e: any) => {
                          setShortCode(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}

            {section == 1 &&
              country != undefined &&
              country != "0" &&
              product != "0" &&
              operator != "0" && (
                <>
                  <Grid item xs={6}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h2>About EN (American English)</h2>
                      {!IsTranslateAbout && (
                        <Button
                          className="dButton"
                          variant="contained"
                          style={{
                            width: "20%",
                            height: "35px",
                            textTransform: "none",
                          }}
                          onClick={handleTranslateAbout}
                        >
                          Translate
                        </Button>
                      )}

                      {IsTranslateAbout && (
                        <Button
                          className="dButton"
                          variant="contained"
                          style={{
                            width: "20%",
                            height: "35px",
                          }}
                        >
                          <CircularProgress color="inherit" size={30} />
                        </Button>
                      )}
                    </div>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorStateChange}
                      />
                    </div>
                  </Grid>

                  <Grid item xs={6}>
                    <h2>About En-Gb (British English)</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorStateEnGb}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorEnGBChange}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <h2>About ES (Spanish)</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorStateEs}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorESChange}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <h2>About FR (French)</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorStateFr}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorFRChange}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <h2>About DE (Dutch)</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorStateDe}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorDEChange}
                      />
                    </div>
                  </Grid>
                  <Grid item xs={6}>
                    <h2>About IT (Italian)</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={editorStateIt}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorITChange}
                      />
                    </div>
                  </Grid>
                </>
              )}
            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product != "0" &&
              operator != "0" && (
                <Grid item xs={12} className="languageHeader">
                  <div
                    style={{
                      display: "flex",
                      marginBottom: 10,
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      {languages.map((lang) => (
                        <button
                          key={lang}
                          className="multiLanTabs"
                          onClick={() => {
                            setActiveLang(lang), setIsTranslateCheck(false);
                          }}
                          style={{
                            backgroundColor:
                              activeLang === lang ? "#1976d2" : "#eee",
                            color: activeLang === lang ? "#fff" : "#000",
                          }}
                        >
                          {lang.toUpperCase()}
                        </button>
                      ))}
                    </div>
                    {!IsTranslateFaq && (
                      <Button
                        className="dButton multilanFaqTranslate"
                        variant="contained"
                        onClick={handleTranslate}
                      >
                        Translate
                      </Button>
                    )}
                    {IsTranslateFaq && (
                      <Button
                        className="dButton multilanFaqTranslate"
                        variant="contained"
                      >
                        <CircularProgress color="inherit" size={30} />
                      </Button>
                    )}
                  </div>
                </Grid>
              )}

            {section == 2 &&
              faqs.length !== 0 &&
              country !== undefined &&
              country !== "0" &&
              product !== "0" &&
              operator !== "0" && (
                <div className="faq-list-container">
                  <h2>Frequently Asked Questions</h2>
                  <Grid item xs={12}>
                    {faqs
                      .filter((faq: any) => faq.language === activeLang) // Filter FAQs by selected language
                      .map((faq: any, index: number) => (
                        <div key={index} className="faq-item">
                          <div className="faq-header">
                            <h3 style={{ padding: "0" }}>
                              Q{faq.faqId}:{faq?.question}
                            </h3>
                            <div className="faq-header">
                              {faq?.isRedeem && (
                                <p className="Redeem">Redeem</p>
                              )}
                              <DriveFileRenameOutlineOutlinedIcon
                                className="edit-button"
                                style={{ marginRight: "20px" }}
                                onClick={() => {
                                  const relatedFaqs = faqs.filter(
                                    (f: any) =>
                                      f.questionCode === faq.questionCode
                                  );
                                  setEditFaqs(relatedFaqs),
                                    setIsCheck(true),
                                    setIsTranslateCheck(true);
                                  setTimeout(() => {
                                    const element = faqSectionRef.current;
                                    if (element) {
                                      const topOffset =
                                        element.getBoundingClientRect().top +
                                        window.pageYOffset -
                                        100;
                                      window.scrollTo({
                                        top: topOffset,
                                        behavior: "smooth",
                                      });
                                    }
                                  }, 100);
                                }}
                              ></DriveFileRenameOutlineOutlinedIcon>
                              <DeleteIcon
                                className="edit-button"
                                onClick={() => {
                                  setDeleteFaq(faq), setDeleteCheck(true);
                                }}
                              ></DeleteIcon>
                            </div>
                          </div>
                          <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                          <hr />
                        </div>
                      ))}
                  </Grid>
                </div>
              )}
            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product != "0" &&
              operator != "0" && (
                <Grid item xs={12}>
                  <div ref={faqSectionRef}>
                    <h2
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      FAQ Section{" "}
                      <Button
                        className="dButton "
                        variant="contained"
                        style={{ width: "10%", height: "35px" }}
                        onClick={() => ClearFaq()}
                      >
                        Clear
                      </Button>
                    </h2>

                    <Grid item xs={12}>
                      <TextField
                        className="formControl"
                        label={`Question for (${activeLang})`}
                        variant="outlined"
                        value={faqData[activeLang]?.question}
                        inputProps={{ maxLength: 200 }}
                        onChange={(e) =>
                          setFaqData((prev: any) => ({
                            ...prev,
                            [activeLang]: {
                              ...prev[activeLang],
                              question: e.target.value,
                            },
                          }))
                        }
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControlLabel
                        style={{ marginLeft: "0px" }}
                        control={
                          <Checkbox
                            checked={faqData[activeLang]?.isRedeem}
                            onChange={(e: any) =>
                              setFaqData((prev: any) => ({
                                ...prev,
                                [activeLang]: {
                                  ...prev[activeLang],
                                  isRedeem: e.target.checked,
                                },
                              }))
                            }
                            inputProps={{ "aria-label": "controlled" }}
                            size="medium"
                          />
                        }
                        label="Redeem"
                        labelPlacement="start"
                      />
                    </Grid>
                    <h2>Answer</h2>
                    <div className="boxShadow editor">
                      <Editor
                        editorState={faqData[activeLang]?.editorState}
                        toolbarClassName="toolbarClassName"
                        wrapperClassName="wrapperClassName"
                        editorClassName="editorScrollable"
                        onEditorStateChange={onEditorFaqChange}
                      />
                    </div>
                  </div>
                </Grid>
              )}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={3} style={{ marginLeft: "30%" }}>
                  {!submitRequest && Open && section != 0 && (
                    <Button
                      className="dButton "
                      variant="contained"
                      onClick={() => handleSave()}
                    >
                      Save
                    </Button>
                  )}
                  {submitRequest && (
                    <Button className="dButton " variant="contained">
                      <CircularProgress color="inherit" size={30} />
                    </Button>
                  )}
                </Grid>
                <Grid item xs={3}>
                  {(display_description ||
                    display_description_en_gb ||
                    display_description_es ||
                    display_description_fr ||
                    display_description_de ||
                    display_description_it) &&
                    country != undefined &&
                    country != "0" &&
                    product != "0" &&
                    operator != "0" &&
                    section == 1 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => setPreview(true)}
                      >
                        Preview
                      </Button>
                    )}
                </Grid>
              </Grid>
            </Grid>
            <Dialog
              className="operator-preview"
              open={preview}
              onClose={() => setPreview(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div style={{ padding: "10px" }}>
                {display_description && (
                  <>
                    <h1>En About</h1>
                    <div
                      dangerouslySetInnerHTML={{ __html: display_description }}
                    />
                  </>
                )}
                {display_description_en_gb && (
                  <>
                    <h1>En-Gb About</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: display_description_en_gb,
                      }}
                    />
                  </>
                )}
                {display_description_es && (
                  <>
                    <h1>ES About</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: display_description_es,
                      }}
                    />
                  </>
                )}
                {display_description_fr && (
                  <>
                    <h1>French About</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: display_description_fr,
                      }}
                    />
                  </>
                )}
                {display_description_de && (
                  <>
                    <h1>Dutch About</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: display_description_de,
                      }}
                    />
                  </>
                )}
                {display_description_it && (
                  <>
                    <h1>Italian About</h1>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: display_description_it,
                      }}
                    />
                  </>
                )}
              </div>
            </Dialog>

            <Dialog
              open={deleteCheck}
              onClose={() => setDeleteCheck(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Delete FAQ Confirmation"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Would you really like to delete this FAQ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  className="dButton dButton2 dbuttonSec"
                  onClick={() => setDeleteCheck(false)}
                >
                  No
                </Button>
                <div style={{ width: "30px" }}></div>
                {!action && (
                  <Button
                    variant="contained"
                    className="dButton dButton2"
                    onClick={() => {
                      deleteFAQ();
                    }}
                    autoFocus
                  >
                    Yes
                  </Button>
                )}
                {action && (
                  <Button className="dButton dButton2" variant="contained">
                    <CircularProgress color="inherit" size={30} />
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};

export default OperatorCms;
